import Hls from 'hls.js';
import type HlsClassType from 'hls.js';
export default Hls;
export type HlsInterface = HlsClassType;
